import AdvancedAudit from './Master/AdvancedAudit.vue';
import AdvancedAuditCapture from './AdvancedAudit/Capture.vue';
import AdvancedAuditCompliance from './ComplianceReport/ComplianceReports.vue';
import AuditIndicatorReport from 'src/views/Pages/Dashboard/AdvancedAudit/AuditIndicatorReport/AuditIndicatorReport.vue';
import AdvancedAuditCreateEdit from 'src/views/Pages/Dashboard/AdvancedAudit/Master/AdvancedAuditCreateEdit.vue';
import ComplianceChart from 'src/views/Pages/Dashboard/AdvancedAudit/ComplianceChart/Report.vue';
import TrendChart from 'src/views/Pages/Dashboard/AdvancedAudit/TrendChart/Report.vue';
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';
import GeneralReport from 'src/views/Pages/Dashboard/AdvancedAudit/GeneralReport/GeneralReport.vue';
import OperatorReport from 'src/views/Pages/Dashboard/AdvancedAudit/OperatorReport/OperatorReport.vue';
import MasterTab from 'src/components/Layouts/MasterTab.vue';
import MatrixReport from 'src/views/Pages/Dashboard/AdvancedAudit/MatrixReport/MatrixReport.vue';
import ReportAdvancedAudit from './Report/Reports.vue';
import SamplingReport from './SamplingReport/SamplingReport.vue';

const AdvancedAuditRoutes = {
  path: 'advanced',
  name: 'audit.audit',
  component: MasterTab,
  props: { reference: 'auditTabs' },
  children: [
    {
      path: 'audits',
      component: EmptyRouterView,
      children: [
        {
          path: 'inspections',
          name: 'audit.audit',
          component: ReportAdvancedAudit,
          meta: {
            prefix_permission: 'advanced_audits_inspections',
          },
        },
      ],
    },
    {
      path: 'audits',
      component: EmptyRouterView,
      children: [
        {
          path: 'samplingreport',
          name: 'audit.audit',
          component: SamplingReport,
          meta: {
            prefix_permission: 'advanced_audits_samplingreport',
          },
        },
      ],
    },
    {
      path: 'audits',
      component: EmptyRouterView,
      children: [
        {
          path: 'admin',
          component: EmptyRouterView,
          children: [
            {
              path: '',
              name: 'audit.audit',
              component: AdvancedAudit,
              meta: {
                prefix_permission: 'advanced_audits_admin',
              },
            },
            {
              path: 'create',
              name: 'audit.audit',
              component: AdvancedAuditCreateEdit,
              meta: {
                prefix_permission: 'advanced_audits_admin',
              },
            },
            {
              path: 'edit',
              name: 'audit.audit',
              component: AdvancedAuditCreateEdit,
              props: true,
              meta: {
                prefix_permission: 'advanced_audits_admin',
              },
            },
          ],
        },
      ],
    },
    {
      path: 'audits',
      component: EmptyRouterView,
      children: [
        {
          path: 'captures',
          name: 'audit.audit',
          component: AdvancedAuditCapture,
          meta: {
            prefix_permission: 'advanced_audits_captures',
          },
        },
      ],
    },
    {
      path: 'audits',
      component: EmptyRouterView,
      children: [
        {
          path: 'compliance',
          name: 'audit.complience_report',
          component: AdvancedAuditCompliance,
          meta: {
            prefix_permission: 'advanced_audits_compliance',
          },
        },
      ],
    },
    {
      path: 'audits',
      component: EmptyRouterView,
      children: [
        {
          path: 'indicatorreport',
          name: 'audit.indicator_report',
          component: AuditIndicatorReport,
          meta: {
            prefix_permission: 'advanced_audits_indicatorreport',
          },
        },
      ],
    },
    {
      path: 'audits',
      component: EmptyRouterView,
      children: [
        {
          path: 'generalreport',
          name: 'audit.general_report',
          component: GeneralReport,
          meta: {
            prefix_permission: 'advanced_audits_generalreport',
          },
        },
      ],
    },
    {
      path: 'audits',
      component: EmptyRouterView,
      children: [
        {
          path: 'matrixreport',
          name: 'audit.matrix_report',
          component: MatrixReport,
          meta: {
            prefix_permission: 'advanced_audits_matrixreport',
          },
        },
      ],
    },
    {
      path: 'audits',
      component: EmptyRouterView,
      children: [
        {
          path: 'compliancechart',
          name: 'audit.compliance_chart',
          component: ComplianceChart,
          meta: {
            prefix_permission: 'advanced_audits_compliancechart',
          },
        },
      ],
    },
    {
      path: 'audits',
      component: EmptyRouterView,
      children: [
        {
          path: 'trendchart',
          name: 'audit.trend_chart',
          component: TrendChart,
          meta: {
            prefix_permission: 'advanced_audits_trendchart',
          },
        },
      ],
    },
    {
      path: 'audits',
      component: EmptyRouterView,
      children: [
        {
          path: 'operatorreport',
          name: 'audit.report_by_operator',
          component: OperatorReport,
          meta: {
            prefix_permission: 'advanced_audits_operatorreport',
          },
        },
      ],
    },
  ],
};

export default AdvancedAuditRoutes;
